import React, { useEffect, useState } from 'react';
import AuthLayout from '../layout';
import { Link } from 'react-router-dom';
import { getAllTenant, getUser, login } from '../../util/APIUtils';
import { allow2Oauth, allowRegister } from '../../constants/config';
import { error } from '../../util/toast';
import { DEFAULT_REDIRECT_URI } from '../../constants';
import { useQuery } from '../../common/hooks/useQuery';
import SocialSignup from '../social-signup';
import * as yup from 'yup';
import { useYupValidationForm } from '../../common/hooks/useYupValidationForm';
import logo from '../../assets/img/logoVinet.svg';
import loginBG from '../../assets/img/bgLogin.png';
import loginBGMobile from '../../assets/img/bgLoginMobile.svg';

import ChangeLang from '../change-lang';
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { GetCurrentLanguage } from '../../util/ChangeLanguage';
import showPass from '../../assets/img/showPass.svg';
import hidePass from '../../assets/img/hidePass.svg';
import useIsTouchDevice from '../../common/hooks';

const validationSchema = yup.object({
  username: yup.string().required('Chưa nhập tài khoản'),
  password: yup.string().required('Chưa nhập mật khẩu'),
});

const Login = () => {
  const { i18n } = useLingui();
  document.title = i18n._(`Đăng nhập VINET`);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useYupValidationForm(validationSchema);
  const query = useQuery();
  const isTouchDevice = useIsTouchDevice();
  const [url, setUrl] = useState();
  const [passwordShown, setPasswordShown] = useState(false);

  const onSubmit = async (data) => {
    try {
      console.log(data);
      // ============================== LOGIN ================================
      const doLogin = await login(data);
      const responseLogin = await doLogin.json();
      const { id_token } = responseLogin;
      if (!id_token) {
        throw new Error(i18n._('Thông tin đăng nhập không chính xác'));
      }
      // ========================== GET USER, TENANT =========================
      const doGetTenant = await getAllTenant(id_token);
      const doGetUser = await getUser(id_token);
      const responseTenant = await doGetTenant.json();
      const responseUser = doGetUser.json();

      // =========================== Handle Redirect =========================
      const stringQuery = new URLSearchParams();
      stringQuery.append('token', id_token); // /redirect?token=${id_token}
      const redirectParam = query.get('redirect');
      let redirectUrl = redirectParam; // if redirect params is defined
      const baseRedirectUrl = redirectUrl
        ? redirectUrl?.split('/')
        : DEFAULT_REDIRECT_URI.split('/');
      if (!redirectUrl) {
        let tenantId = 0;
        const theirTenant = responseTenant.filter(
          (item) => (item.tenantDTO.userId = responseUser.id),
        ); // find tenants was created by user
        const tenantUserHasRole = responseTenant.filter(
          (item) => item.listRoleOfUserInTenant.length > 0,
        ); // find the tenant which user has role
        if (theirTenant.length > 0) {
          tenantId = theirTenant[0].tenantDTO.id;
        } else if (tenantUserHasRole.length > 0) {
          tenantId = tenantUserHasRole[0].tenantDTO.id;
        }
        redirectUrl = `${DEFAULT_REDIRECT_URI}/o/${tenantId}`;
      }
      stringQuery.append('url', redirectUrl);

      const curLang = GetCurrentLanguage();
      setUrl(
        `${baseRedirectUrl[0]}//${
          baseRedirectUrl[2]
        }/redirect?${stringQuery.toString()}&lang=${curLang}`,
      );
    } catch (err) {
      if (err.message) {
        error(err.message);
      } else {
        error(
          (err && err.detail) || (
            <Trans>Trùng thông tin với tài khoản đã có trong hệ thống</Trans>
          ),
        );
      }
    }
  };

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  useEffect(() => {
    if (url) {
      window.location.href = url;
    }
  }, [url]);

  return (
    <AuthLayout>
      {!isTouchDevice ? (
        <div className="block">
          <div className="w-full md:flex bg-[#FFFFFF]">
            <div
              className="relative bg-no-repeat flex flex-col justify-center "
              style={{
                backgroundImage: `url(${loginBG})`,
                backgroundSize: 'contain',
              }}
            >
              <div
                className="py-2 md:w-9/12 w-3/12 ml-auto"
                style={{ position: 'relative', bottom: '100px' }}
              >
                <a href={DEFAULT_REDIRECT_URI}>
                  <img
                    src={logo}
                    className="md:w-2/3 mx-auto"
                    alt="Logo VINET"
                  />
                </a>
                <span className="md:block hidden pt-6 font-semibold text-center text-[#42526E] text-[32px]">
                  <Trans>Nền tảng đổi mới sáng tạo mở Việt Nam VINET</Trans>
                </span>
              </div>
            </div>
            <div className="md:w-6/12 w-full h-full md:min-h-screen flex flex-col relative">
              <div className="flex justify-end absolute top-2 right-2">
                <ChangeLang />
              </div>
              <div className="">
                <div
                  className="w-full text-center md:text-4xl pt-28 text-2xl font-bold"
                  style={{ color: '#007DC5' }}
                >
                  <Trans>Đăng nhập</Trans>
                </div>
                <form
                  className={'flex flex-col pt-10'}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div>
                    <div className="md:w-[330px] w-10/12 mx-auto">
                      <div className={''}>
                        <div
                          className="font-bold text-sm"
                          style={{ color: '#172B4D' }}
                        >
                          <Trans>Login Account</Trans>
                        </div>
                        <input
                          className={`w-full mt-2.5 px-4 py-2 text-sm border placeholder-[#C3CFE2] rounded-lg ${
                            errors.username
                              ? 'border-red-500'
                              : 'border-[#C3CFE2]'
                          }`}
                          name="username"
                          placeholder={i18n._(`Tài khoản`)}
                          {...register('username', {})}
                        />
                        {errors.username?.message && (
                          <div
                            className={`text-right text-red-500 text-sm mr-2 mt-1`}
                          >
                            {errors.username?.message}
                          </div>
                        )}
                      </div>
                      <div className={'mt-6'}>
                        <div
                          className="font-bold text-sm"
                          style={{ color: '#172B4D' }}
                        >
                          <Trans>Mật khẩu</Trans>
                        </div>
                        <div className="relative flex">
                          <input
                            className={`w-full mt-2 py-2 px-4 border placeholder-[#C3CFE2] rounded-lg text-sm ${
                              errors.password
                                ? 'border-red-500'
                                : 'border-[#C3CFE2]'
                            }`}
                            placeholder={i18n._('Mật khẩu (*)')}
                            {...register('password')}
                            name="password"
                            type={passwordShown ? 'text' : 'password'}
                          />
                          <div
                            onClick={togglePasswordVisiblity}
                            className="absolute right-3.5 top-1/2 -translate-y-1/3"
                          >
                            {passwordShown ? (
                              <img src={showPass} />
                            ) : (
                              <img src={hidePass} />
                            )}
                          </div>
                        </div>
                        <div
                          className={`text-right text-red-500 text-sm mr-2 mt-1`}
                        >
                          {errors.password?.message}
                        </div>
                      </div>
                      <div className={'relative'}>
                        <div
                          className={
                            'text-right cursor-pointer hover:underline absolute right-[-100px] pt-2'
                          }
                        >
                          <Link to="/forgot-password">
                            <span
                              className="text-sm"
                              style={{ color: '#007DC5', marginRight: '100px' }}
                            >
                              <Trans>Quên mật khẩu</Trans>
                            </span>
                          </Link>
                        </div>
                      </div>
                      <div
                        className={
                          'mx-auto w-full text-center md:px-5 px-4 mt-20'
                        }
                      >
                        <button
                          className={
                            ' text-white bg-[#F26F27] py-2 w-full rounded-lg'
                          }
                          type={'submit'}
                          style={{
                            width: '270px',
                            height: '48px',
                          }}
                        >
                          <Trans>Đăng nhập</Trans>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              {allow2Oauth === true && (
                <>
                  <div
                    className={'lg:block md:hidden mx-auto pt-10 w-10/12 flex'}
                  >
                    <SocialSignup
                      redirect={
                        query.get('redirect') || `${DEFAULT_REDIRECT_URI}/o/0`
                      }
                    />
                  </div>
                </>
              )}
              {allowRegister === true && (
                <>
                  <div className="md:flex w-full justify-center py-[16px]">
                    <p
                      className="text-center"
                      style={{
                        color: '#172B4D',
                        fontSize: '16px',
                        fontWeight: '400',
                        fontStyle: 'normal',
                      }}
                    >
                      <Trans>Bạn chưa có tài khoản?</Trans>
                    </p>
                    <Link
                      to={
                        query.get('redirect')
                          ? `/signup?redirect=${query.get('redirect')}`
                          : '/signup'
                      }
                    >
                      <div
                        className={
                          'mx-2 font-bold underline text-center text-[#007DC5]'
                        }
                      >
                        <Trans>Nhấn vào đây để đăng ký</Trans>
                      </div>
                    </Link>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="block">
          <div className="w-full flex flex-col bg-[#FFFFFF]">
            <div className=" w-full h-full flex flex-col relative">
              <div
                className="relative h-[275px] mx-10"
                style={{
                  backgroundImage: `url(${loginBGMobile})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              >
                <div
                  className="flex flex-col mt-[11.5rem] py-2 w-full"
                  style={{ position: 'relative', bottom: '100px' }}
                >
                  <a href={DEFAULT_REDIRECT_URI}>
                    <img
                      src={logo}
                      className=" aspect-4/3 w-[166px] h-[61px] mx-auto"
                      alt="Logo VINET"
                    />
                  </a>
                  <span className="pt-4 font-semibold text-center text-[#42526E] items-center leading-[30px] text-[20px]">
                    <Trans>Nền tảng đổi mới sáng tạo mở Việt Nam VINET</Trans>
                  </span>
                </div>
              </div>
              <div className="flex justify-end absolute top-2 right-2">
                <ChangeLang />
              </div>
              <div className="">
                <div
                  className="w-full text-center text-[26px] font-bold"
                  style={{ color: '#007DC5' }}
                >
                  <Trans>Đăng nhập</Trans>
                </div>
                <form
                  className={'flex flex-col pt-6 mx-4'}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div>
                    <div className="w-full">
                      <div className={''}>
                        <div
                          className="font-semibold "
                          style={{ color: '#172B4D' }}
                        >
                          <Trans>Login Account</Trans>
                        </div>
                        <input
                          className={`w-full mt-2 px-4 py-2 text-sm border placeholder-[#C3CFE2] rounded-lg ${
                            errors.username
                              ? 'border-red-500'
                              : 'border-[#C3CFE2]'
                          }`}
                          name="username"
                          placeholder={i18n._(`Tài khoản`)}
                          {...register('username', {})}
                        />
                        {errors.username?.message && (
                          <div
                            className={`text-right text-red-500 text-sm mr-2 mt-1`}
                          >
                            {errors.username?.message}
                          </div>
                        )}
                      </div>
                      <div className={'mt-6'}>
                        <div
                          className="font-semibold"
                          style={{ color: '#172B4D' }}
                        >
                          <Trans>Mật khẩu</Trans>
                        </div>
                        <div className="relative flex">
                          <input
                            className={`w-full mt-2 py-2 px-4 border placeholder-[#C3CFE2] rounded-lg text-sm ${
                              errors.password
                                ? 'border-red-500'
                                : 'border-[#C3CFE2]'
                            }`}
                            placeholder={i18n._('Mật khẩu (*)')}
                            {...register('password')}
                            name="password"
                            type={passwordShown ? 'text' : 'password'}
                          />
                          <div
                            onClick={togglePasswordVisiblity}
                            className="absolute right-3.5 top-1/2 -translate-y-1/3"
                          >
                            {passwordShown ? (
                              <img src={showPass} />
                            ) : (
                              <img src={hidePass} />
                            )}
                          </div>
                        </div>
                        <div
                          className={`text-right text-red-500 text-sm mr-2 mt-1`}
                        >
                          {errors.password?.message}
                        </div>
                      </div>
                      <div className={'relative'}>
                        <div
                          className={
                            ' cursor-pointer absolute right-[2px] pt-2'
                          }
                        >
                          <Link to="/forgot-password">
                            <span
                              className="text-sm"
                              style={{
                                color: '#007DC5',
                                textDecoration: 'underline',
                              }}
                            >
                              <Trans>Quên mật khẩu?</Trans>
                            </span>
                          </Link>
                        </div>
                      </div>
                      <div
                        className={
                          'mx-auto w-full text-center md:px-5 px-4 mt-20'
                        }
                      >
                        <button
                          className={
                            ' text-white font-medium bg-[#F26F27] py-2 w-full rounded-lg'
                          }
                          type={'submit'}
                          style={{
                            width: '270px',
                            height: '48px',
                          }}
                        >
                          <Trans>Đăng nhập</Trans>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              {allow2Oauth === true && (
                <>
                  <div className={'justify-center mx-auto pt-12 flex'}>
                    <SocialSignup
                      redirect={
                        query.get('redirect') || `${DEFAULT_REDIRECT_URI}/o/0`
                      }
                    />
                  </div>
                </>
              )}
              {allowRegister === true && (
                <>
                  <div className="flex w-full text-[14px] justify-center pt-2 pb-10">
                    <p
                      className="text-center flex items-center mt-[2px]"
                      style={{
                        color: '#172B4D',
                        fontWeight: '400',
                        fontStyle: 'normal',
                      }}
                    >
                      <Trans>Bạn chưa có tài khoản?</Trans>
                    </p>
                    <Link
                      to={
                        query.get('redirect')
                          ? `/signup?redirect=${query.get('redirect')}`
                          : '/signup'
                      }
                    >
                      <div
                        className={
                          'ml-1 mt-0.5 underline text-center font-medium text-[#007DC5]'
                        }
                      >
                        <Trans>Nhấn vào đây để đăng ký</Trans>
                      </div>
                    </Link>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </AuthLayout>
  );
};

export default Login;
